<script lang="ts">
	import arrowRightIcon from "@assets/icons/arrow_right_alt.svg?raw";
	import imgLab from "@assets/images/lab.jpg";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import Media from "@components/common/Media.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import { Category } from "@core/schema/Category.js";
	import type { Subcategory } from "@core/schema/Subcategory.js";
	import { categoryNameMap } from "@core/schema/names/categoryNameMap.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";

	const { tenant } = getGlobalTemplateProps();

	const categoryImageMap: Record<Category, string> = {
		[Category.CytogeneticsAndMolecularGenetics]: imgLab,
		[Category.FreeRadicals]: imgLab,
	};

	const { subcategories, noHeadline = false }: { subcategories: Subcategory[]; noHeadline?: boolean } = $props();
</script>

<section class="grid-container grow full-width bg-gradient-to-t from-light/50 to-light py-10 lg:py-20">
	{#if !noHeadline}
		<h2 class="text-center max-w-60 lg:max-w-xl mx-auto mb-6 lg:mb-20 max-lg:text-xl">
			<Formatted text="clb[[Jaké produkty]] dodáváme" />
		</h2>
	{/if}
	{#each Object.values(Category) as category, index (category)}
		{@const name = categoryNameMap[category][tenant.locale]}
		{@const subcategoriesOfCategory = subcategories.filter((subcategory) => subcategory.category === category)}
		<div
			class={[
				"flex flex-col justify-between lg:flex-row items-center gap-8 lg:gap-24 mb-8 lg:mb-12",
				index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse",
			]}
		>
			<Media
				class="rounded-lg max-lg:w-40 hidden lg:block"
				source={{ src: categoryImageMap[category], type: "image/jpeg" }}
				width={400}
				height={400}
				alt="Obrázek {name}"
			/>
			<div class="grow">
				<h3 class="max-lg:text-lg max-lg:max-w-60 text-blue mb-5">
					<Formatted text={name} />
				</h3>
				<ul
					class={[
						"custom-list grid mb-3 lg:mb-8 gap-x-6",
						subcategoriesOfCategory.length > 8 ? "grid-cols-2" : "grid-cols-1",
					]}
				>
					{#each subcategoriesOfCategory as subcategory (subcategory.id)}
						<li>{subcategory.name[tenant.locale]}</li>
					{/each}
				</ul>
				<Link
					class="flex items-center justify-center gap-1"
					variant={ButtonVariant.Primary}
					href={getCategoryPath(tenant, category)}
				>
					<span>Zobrazit vše</span>
					<Icon icon={arrowRightIcon} class="w-3.5" /></Link
				>
			</div>
		</div>
	{/each}
</section>
